import React, { useRef, useState } from 'react';
import { Icon } from '@/Components/Icon/Icon';
import { Icons } from '@/Static/IconsRes';
import Button from 'devextreme-react/button';
import styles from './TableExportButton.scss';
import Popover from 'devextreme-react/popover';
import { formatMessage } from 'devextreme/localization';
import { useLocalization } from '@/Hooks';
import { Tooltip } from '@/Components/Tooltip/Tooltip';
import { ExportFormatType } from '@/Enums/ExportFormatType';

type Props = {
  onExport: (format: ExportFormatType, value: boolean) => void;
};

export const TableExportButton = ({ onExport }: Props): React.ReactElement => {
  const {
    common: {
      Actions: { ExportData },
    },
  } = useLocalization();

  const [visible, setVisible] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  const handleClick = (format: ExportFormatType, onlySelected: boolean) => () => {
    onExport(format, onlySelected);
    setVisible(false);
  };

  return (
    <div ref={wrapperRef}>
      <Tooltip text={ExportData}>
        <Button className={styles.button} onClick={() => setVisible(!visible)}>
          <Icon alt="exportIcon" src={Icons.Outcoming} className={styles.icon} id={'tableExportButton'} />
        </Button>
      </Tooltip>

      <Popover
        minWidth={150}
        position="bottom"
        visible={visible}
        showCloseButton={false}
        target={wrapperRef.current as Element}
        onHiding={() => setVisible(false)}
      >
        <div className={styles.block}>
          <div onClick={handleClick(ExportFormatType.Xlsx, false)}>
            <Icon alt="tableExport" src={Icons.Outcoming} className={styles.exportIcon} />
            <span>{formatMessage('dxDataGrid-exportAll')} (.xlsx)</span>
          </div>

          <div onClick={handleClick(ExportFormatType.Csv, false)}>
            <Icon alt="tableExport" src={Icons.Outcoming} className={styles.exportIcon} />
            <span>{formatMessage('dxDataGrid-exportAll')} (.csv)</span>
          </div>

          <div onClick={handleClick(ExportFormatType.Xlsx, true)}>
            <Icon alt="tableExport" src={Icons.OutcomingSelected} className={styles.exportIcon} />
            <span>{formatMessage('dxDataGrid-exportSelectedRows')} (.xlsx)</span>
          </div>

          <div onClick={handleClick(ExportFormatType.Csv, true)}>
            <Icon alt="tableExport" src={Icons.OutcomingSelected} className={styles.exportIcon} />
            <span>{formatMessage('dxDataGrid-exportSelectedRows')} (.csv)</span>
          </div>
        </div>
      </Popover>
    </div>
  );
};
